import { View, Text, StyleSheet } from 'react-native'
import { DesignSystem } from '@/src/design-system'
import { formatCurrency, formatNumber } from '../../common/utils/general'
import { Skeleton } from 'moti/skeleton'
import { mesaColorNames, typography } from '@/src/common/theme'

export function PointConversionInfoCard({
  pointsBalance,
  dollarsPerPointConversion,
  currentBalance,
  conversionRatePointsExample = 10_000,
}: {
  pointsBalance: number | 'loading'
  dollarsPerPointConversion: number
  currentBalance?: number | 'loading'
  conversionRatePointsExample?: number
}) {
  return (
    <DesignSystem.Card style={styles.whiteBlock}>
      <View style={styles.pointsContainer}>
        <Text style={typography['label/sm-bold']}>Mesa Points</Text>
        {pointsBalance === 'loading' ? (
          <Skeleton colorMode="light" height={38.4} width={123} />
        ) : (
          <Text style={typography['heading/heading1']}>{pointsBalance.toLocaleString()}</Text>
        )}
      </View>
      <View style={styles.infoContainer}>
        <View style={styles.infoRow}>
          <Text style={styles.infoRowHeader}>Conversion Rate</Text>
          <Text style={typography['label/sm-bold']}>
            {`${formatNumber(conversionRatePointsExample)} Points = ${formatCurrency(
              String(dollarsPerPointConversion * conversionRatePointsExample),
              { decimals: 0 },
            )}`}
          </Text>
        </View>
        {(currentBalance || currentBalance === 0) && (
          <View style={styles.infoRow}>
            <Text style={styles.infoRowHeader}>Current Balance</Text>
            {currentBalance === 'loading' ? (
              <Skeleton colorMode="light" height={14} width={88} />
            ) : (
              <Text style={typography['label/sm-bold']}>{formatCurrency(`${currentBalance}`)}</Text>
            )}
          </View>
        )}
      </View>
    </DesignSystem.Card>
  )
}

const styles = StyleSheet.create({
  whiteBlock: {
    borderRadius: 12,
    padding: 16,
    gap: 24,
  },
  pointsContainer: {
    gap: 8,
  },
  infoContainer: {
    gap: 16,
  },
  infoRow: {
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  infoRowHeader: {
    ...typography['label/sm-regular'],
    color: mesaColorNames['Greyscale/500 #6E7375'],
  },
})
